import styled from 'styled-components';
import { boxShadow1 } from 'utils/style/colors';

export const List = styled.div`
  flex: 1;
  transition: box-shadow 0.25s;
  padding: 0 !important;
  border-radius: 0 0 10px 10px;
  background-color: var(--exact-white);
  -webkit-box-shadow: ${boxShadow1};
  box-shadow: ${boxShadow1};
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
